"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubHeader = exports.Split = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const styled_components_1 = require("../styled-components");
const Layout_1 = require("../Layout");
const ErrorBoundary_1 = require("../ErrorBoundary");
const EnhancedWrapper = (0, styled_components_1.styled)(Layout_1.Flex) `
  height: 100%;
  flex-wrap: nowrap;
  @media (max-width: ${({ theme }) => theme.screen.medium}) {
    flex-direction: column;
  }
`;
const Column = styled_components_1.styled.div `
  flex: 1 1 auto;
  width: 100%;
  height: 100%;
  position: relative;
  overflow: auto;
  :nth-child(1) {
    border-right: 1px solid #555;
  }
  @media (max-width: ${({ theme }) => theme.screen.medium}) {
    border-right: none;
    border-bottom: 1px solid #555;
  }
`;
class Split extends react_1.default.PureComponent {
    render() {
        return (react_1.default.createElement(EnhancedWrapper, null,
            react_1.default.createElement(Column, null,
                react_1.default.createElement(ErrorBoundary_1.ErrorBoundary, null,
                    react_1.default.createElement(Layout_1.Gutter, { padding: this.props.gutterPadding, style: { maxHeight: "100vh", height: "100%" } }, this.props.left))),
            react_1.default.createElement(Column, null,
                react_1.default.createElement(ErrorBoundary_1.ErrorBoundary, null,
                    react_1.default.createElement(Layout_1.Gutter, { padding: this.props.gutterPadding, style: { maxHeight: "100vh", height: "100%" } }, this.props.right)))));
    }
}
exports.Split = Split;
exports.SubHeader = (0, styled_components_1.styled)(Layout_1.Flex) `
  padding: 10px ${(props) => props.theme.gutter};
  @media (max-width: ${({ theme }) => theme.screen.small}) {
    padding: 10px;
  }
`;
//# sourceMappingURL=Split.js.map